import {isNil} from 'ramda';

import {getSafely} from 'shared/web';

type FilterValue = string | number | string[] | number[] | undefined | null;

export const composeQueryParams = <T extends Record<string, FilterValue>>(
  filters: T,
  keys?: Array<keyof T>
) => {
  const keysToUse = keys ?? (Object.keys(filters) as Array<keyof T>);

  const params = keysToUse
    .map((key) => {
      const value = getSafely(filters, key);

      if (isNil(value)) {
        return null;
      }

      if (Array.isArray(value)) {
        return `${String(key)}=${value.join(',')}`;
      }

      return `${String(key)}=${value}`;
    })
    .filter((param): param is string => param !== null);

  return params;
};
